import { render, staticRenderFns } from "./WidgetPartitionsWatermetersTreeview.vue?vue&type=template&id=55bf020b&scoped=true&"
import script from "./WidgetPartitionsWatermetersTreeview.vue?vue&type=script&lang=js&"
export * from "./WidgetPartitionsWatermetersTreeview.vue?vue&type=script&lang=js&"
import style0 from "./WidgetPartitionsWatermetersTreeview.vue?vue&type=style&index=0&id=55bf020b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bf020b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VChip,VCol,VIcon,VRow,VTooltip,VTreeview})
